import { render, staticRenderFns } from "./deliveryHistoryOrder.vue?vue&type=template&id=0d60b83f&scoped=true"
import script from "./deliveryHistoryOrder.vue?vue&type=script&lang=js"
export * from "./deliveryHistoryOrder.vue?vue&type=script&lang=js"
import style0 from "./deliveryHistoryOrder.vue?vue&type=style&index=0&id=0d60b83f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d60b83f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\space\\tops\\tops-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d60b83f')) {
      api.createRecord('0d60b83f', component.options)
    } else {
      api.reload('0d60b83f', component.options)
    }
    module.hot.accept("./deliveryHistoryOrder.vue?vue&type=template&id=0d60b83f&scoped=true", function () {
      api.rerender('0d60b83f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/delivery/deliveryHistoryOrder.vue"
export default component.exports